var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 14.6875H7.84375C5.71789 14.6875 4.65496 14.6875 3.81651 15.0348C2.69857 15.4979 1.81037 16.3861 1.3473 17.504C1 18.3425 1 19.4054 1 21.5312M16.3984 1.33165C18.0705 2.00848 19.25 3.64775 19.25 5.5625C19.25 7.47725 18.0705 9.11652 16.3984 9.79335M14.1172 5.5625C14.1172 8.0823 12.0745 10.125 9.55469 10.125C7.03489 10.125 4.99219 8.0823 4.99219 5.5625C4.99219 3.0427 7.03489 1 9.55469 1C12.0745 1 14.1172 3.0427 14.1172 5.5625Z",
    stroke: "#292929",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4062 19.25L14.6875 21.5312L19.25 16.9688",
    stroke: "#273961",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsicon);
export default __webpack_public_path__ + "static/media/Patients icon.7e112f26fbeec475e94bf9f1706f3f55.svg";
export { ForwardRef as ReactComponent };